import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const OFFERINGS = [
    {
        num: "01",
        title: "AI readiness assessment",
        desc: "A plain-English check of where your business stands with AI today — data, tools and risks — and what to fix first.",
    },
    {
        num: "02",
        title: "3 automation opportunities",
        desc: "The three highest-value tasks worth automating first, with the time and cost each one could save you.",
    },
    {
        num: "03",
        title: "ChatGPT / AI setup",
        desc: "Your ChatGPT or AI tools set up properly and safely — accounts, access and guardrails done right from day one.",
    },
    {
        num: "04",
        title: "Prompt library",
        desc: "A ready-made library of prompts for your everyday work — quotes, emails, reports — built around your business.",
    },
    {
        num: "05",
        title: "Staff training",
        desc: "Hands-on sessions so your team actually uses the tools confidently — not just on day one.",
    },
    {
        num: "06",
        title: "30-day implementation plan",
        desc: "A week-by-week plan to go from assessment to live within a month, with us checking in along the way.",
    },
];

const PACKAGE_VALUE = "Small Business — AI & Automation Package";

export default function SmallBusiness({ onEnquire }) {
    return (
        <section id="smallbusiness" data-testid="smallbusiness-section">
            <div className="wrap">
                <motion.div
                    className="smallbiz-eyebrow"
                    data-testid="smallbusiness-eyebrow"
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.7, ease: EASE }}
                >
                    SMALL BUSINESS — AI &amp; AUTOMATION PACKAGE
                </motion.div>

                <motion.div
                    className="section-head"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8, ease: EASE }}
                >
                    <div>
                        <h2 data-testid="smallbusiness-heading">
                            For small businesses, we help with the following
                        </h2>
                    </div>
                    <p className="section-desc">
                        One fixed-scope package — we assess, set up, train and
                        hand you a working 30-day plan. No jargon, no lock-in.
                    </p>
                </motion.div>

                <div className="smallbiz-ledger">
                    {OFFERINGS.map((o, i) => (
                        <motion.div
                            className={`smallbiz-item smallbiz-item-${o.num}`}
                            key={o.num}
                            data-testid={`smallbusiness-item-${i + 1}`}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.25 }}
                            transition={{
                                duration: 0.7,
                                ease: EASE,
                                delay: (i % 2) * 0.08,
                            }}
                        >
                            <div className="smallbiz-item-head">
                                <span className="smallbiz-item-num">{o.num}</span>
                                <h3 className="smallbiz-item-title">{o.title}</h3>
                            </div>
                            <p className="smallbiz-item-desc">{o.desc}</p>
                            <button
                                className="smallbiz-item-cta-link"
                                data-testid={`smallbusiness-enquire-${i + 1}`}
                                onClick={() => onEnquire(PACKAGE_VALUE)}
                            >
                                Enquire about this
                            </button>
                        </motion.div>
                    ))}
                </div>

                <motion.div
                    className="smallbiz-cta-bar"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.7, ease: EASE }}
                >
                    <div className="smallbiz-cta-content">
                        <div className="smallbiz-cta-title">
                            Everything above, delivered inside 30 days.
                        </div>
                        <div className="smallbiz-cta-sub">
                            Fixed scope · plain English · you keep everything we build
                        </div>
                    </div>
                    <button
                        className="service-cta"
                        data-testid="smallbusiness-package-enquire-btn"
                        onClick={() => onEnquire(PACKAGE_VALUE)}
                    >
                        Enquire about the package
                    </button>
                </motion.div>
            </div>
        </section>
    );
}
